import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withFormikField } from 'utils/formik';
import { Field } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
const StyledField = styled(Field)`
  width: 100%;
`;

const ClientReference = ({ field, form, intl, ...props }) => {
  const t = intl.messages.modules.clientReference;
  return <StyledField {...props} label={t.label} />;
};

ClientReference.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

ClientReference.defaultProps = {
  field: 'client_reference',
};

export default withFormikField(injectIntl(ClientReference));
